import { findGetParameter } from "../../../components/utilities/UtilityFunctions";
import EventAboutDefault from "./EventAbout/EventAboutDefault";

export default function EventAbout(props) {
  const {
    handleTabChange,
    tabIndexes,
    refreshEvent,
    setEvent,
    activeTab,
    authContext,
    followEvent,
    following,
  } = props;

  let event = props.event;

  if (event?.overview) {
    event = {
      ...event,
      ...event.overview,
    };
    delete event.overview;
  }

  const registerParam = findGetParameter("register") === "true";

  return (
    <EventAboutDefault
      event={event}
      setEvent={setEvent}
      activeTab={activeTab}
      handleTabChange={handleTabChange}
      tabIndexes={tabIndexes}
      authContext={authContext}
      refreshEvent={refreshEvent}
      followEvent={followEvent}
      following={following}
      registerParam={registerParam}
    />
  );
}
